import styled from 'styled-components';
import {maskImage, BGImageCenter} from '../../../../../../../globalVariables/GlobalVariables';
import {getPrimitive, getSpacing} from '@tickchak/react-share/app';

export const priceButtonWrapper = styled.div`
    position: relative;
    button {
        padding: ${getSpacing('spaceSm')}
    }
`;

export const priceIcon = styled.div<{icon: string}>`
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: ${getPrimitive('turquoise.turquoise400')};
    position: relative;
    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        ${p => p.icon && maskImage(p.icon, getPrimitive('solids.black'), '16px', 'center')};
        background-image: none;
    }
`;

